import React, {} from "react";
import { MdRefresh as Ico } from 'react-icons/md';
// Components
import CommonButton from "../../common/button/button";

const ButtonRefresh = ({ config, setRefreshData }) => {

  let caption = "Refrescar"
  let onClick = () => { setRefreshData(true) };
  let width = "123px";
  let marginLeft = "0px";
  if (!!config) {
    if (config.visible === false) return null;
    caption = config.caption || caption;
    width = config.width || width;
    marginLeft = config.marginLeft || marginLeft;
  }
  return (
    <CommonButton 
      onClick={onClick} 
      style={{
        width,
        marginLeft,
        display: "flex", // Use flexbox to control alignment
        alignItems: "center", // Center icon and text vertically
        justifyContent: "flex-start", // Align icon and text to the left
        gap: "6px", // Add spacing between icon and text
      }}
      inverted={true}
    >
      <Ico size={18} />
      <span>{caption}</span>
    </CommonButton>
  );
};

export default ButtonRefresh;
